import $ from 'jquery';
import 'focus-visible';
import 'nodelist-foreach-polyfill';

import DDTemplates from './DDTemplates';
import Drupal from './Drupal';
import Header from './Header';
import Toolbar from './Toolbar';
import { viewport } from './Viewport';
import Sticky from './Sticky';
import Gallery from './Gallery';
import Navigation from './Navigation';
import SmartFooter from './SmartFooter';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
import AccordionWrap from './AccordionWrap';
import AccordionFix from './AccordionFix';
import AccordionContainer from './AccordionContainer';
import RelocateSearch from './RelocateSearch';
import RelocateHeaderlinks from './RelocateHeaderlinks';
import Modaal from './Modaal';
import BackgroundImage from './BackgroundImage';
import AnchorTag from './AnchorTags';
import FlickityHomeStats from './Flickity.HomeStats';
import FlickityHomePillars from './Flickity.HomePillars';
import StringSplit from './StringSplit';

// Add the theme behaviors
Drupal.behavior((context) => {
  // Helpers
  const $body = $(document.body, context);

  // DD Template Behaviors
  if (!document.body.DDTemplates) {
    document.body.DDTemplates = new DDTemplates(context);
  }

  // Replace Lightbox lightframe functionality with Modaal.
  document.querySelectorAll('.open-lightframe').forEach((element) => {
    if (!element.Modaal) {
      const selector = '.node-header a, .field-image a, .link-read-more a';
      element.Modaal = new Modaal(element, selector);
    }
  });

  // Replace Lightbox slideshow functionality with Modaal.
  document.querySelectorAll('.te-open-slideshow .node, .te-open-slideshow.node').forEach((element) => {
    if (!element.Modaal) {
      const selector = '.field-image a';
      element.Modaal = new Modaal(element, selector);
    }
  });

  // Replace Lightbox and Lighframe straggelers.
  $('[rel^=lightbox], [rel^=lightframe]', context).closest('.node').each((i, element) => {
    if (!element.Modaal) {
      // const selector = '.node-header a, .field-image a, .link-read-more a';
      const selector = '.field-image a';
      element.Modaal = new Modaal(element, selector);
    }
  });

  // Fix our damn menus from displaying orphaned children
  $('.main-navigation, .term-navigation', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Sticky sidebars
  $('.page-sidebar', context).each((i, element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main Navigation
  $('#nice-menu-3', context).each((i, element) => {
    if (!element.Navigation) {
      element.Navigation = new Navigation(element);
    }
  });

  // Controls the states of the menu and search states
  $('.toolbar', context).each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Relocate search based on media query
  $('.site-search', context).each((i, element) => {
    if (!element.RelocateSearch) {
      element.RelocateSearch = new RelocateSearch(element);
    }
  });

  // Relocate headerlinks based on media query
  $('.headerlinks', context).each((i, element) => {
    if (!element.Relocateheaderlinks) {
      element.Relocateheaderlinks = new RelocateHeaderlinks(element);
    }
  });

  // Controls the page overlay display
  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js
  $('.headroom', context).each((i, element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Smart Footer
  $('.page-footer', context).each((i, element) => {
    if (!element.SmartFooter) {
      const $reactiveElement = $('.page', context);
      element.SmartFooter = new SmartFooter(element, $reactiveElement);
    }
  });

  // Term Navigation
  $('.term-navigation', context).each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Photo Galleries
  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.Gallery) {
      element.Gallery = new Gallery(element);
    }
  });

  // Wraps each accordion element
  $('.accordion-heading', context).each((i, element) => {
    if (!element.accordionWrap) {
      element.accordionWrap = new AccordionWrap(element);
      element.accordionWrap = new AccordionFix(element);
    }
  });

  // Wraps each accordion in a container
  $('.node-content', context).each((i, element) => {
    if (!element.accordionContainer) {
      setTimeout(() => {
        element.accordionContainer = new AccordionContainer(element);
      }, 300);
    }
  });

  $('a[href*="#"]:not([href="#"])', context).each((i, element) => {
    if (!element.anchorTag) {
      element.anchorTag = new AnchorTag(element);
    }
  });

  // Calendar of Events View
  $('.calendar-feed', context).each((i, element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element);
    }
  });

  // Background Images
  $('.banner', context).each((i, element) => {
    if (!element.bannerBgImage) {
      element.bannerBgImage = new BackgroundImage(element, {
        sourceSelector: 'figure img',
        destSelector: '.banner-bg',
      });
    }
  });

  $('.hero', context).each((i, element) => {
    if (!element.heroBgImage) {
      element.heroBgImage = new BackgroundImage(element, {
        sourceSelector: '.field-image img',
        destSelector: '.node-image',
      });
    }
  });

  $('.home-stats', context).each((i, element) => {
    if (!element.statsBgImage) {
      element.statsBgImage = new BackgroundImage(element, {
        sourceSelector: '.field-image img',
        destSelector: '.node-image .field-image',
      });
    }
  });

  $('.home-pillars .views-row, .home-stories .views-row, .home-story .views-row', context).each((i, element) => {
    if (!element.pillarBgImage) {
      element.pillarBgImage = new BackgroundImage(element, {
        sourceSelector: 'img',
        destSelector: '.node-image-inner',
      });
    }
  });

  // Flickity Slider
  $('.home-stats', context).each((i, element) => {
    if (!element.homeStatsSlider) {
      element.homeStatsSlider = new FlickityHomeStats(element);
    }
  });
  $('.home-pillars', context).each((i, element) => {
    if (!element.homePillarsSlider) {
      element.homePillarsSlider = new FlickityHomePillars(element);
    }
  });

  // Split text at verticle pipe
  $('.home-stats .flickity-slider', context).each((i, element) => {
    if (!element.stringSplit) {
      element.stringSplit = new StringSplit(element, {
        title: 'li',
        divider: '|',
      });
    }
  });

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }

  // Force Viewport Update
  viewport.update();
});
